export default __webpack_public_path__ + "4ec02dc0b1c1ceab7d988c3d1529abcc.svg";